/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ISearchState {
  search: string;
}

const initialState: ISearchState = {
  search: ''
};

export const searchSlice = createSlice({
  name: 'globalSearch',
  initialState,
  reducers: {
    setSearch: (state: ISearchState, param: PayloadAction<string>) => {
      const { payload } = param;
      state.search = payload;
    }
  }
});

const { actions, reducer } = searchSlice;
export const { setSearch } = actions;
export default reducer;
